/** 跨页面共用的状态文案与标签配色（只收两个及以上文件共用的映射） */

/** 训练 run 状态（训练任务页与训练详情抽屉共用一套） */
export const TRAIN_STATES = {
  running: { label: '训练中', tag: 'warning' },
  finished: { label: '已完成', tag: 'success' },
  finished_no_artifact: { label: '产物不全', tag: 'warning' },
  failed: { label: '失败', tag: 'danger' },
  stopped: { label: '已停止', tag: 'info' },
  unknown: { label: '未知', tag: 'info' },
};

/** 点了停止、容器还在跑完当前这一轮：状态列显示「停止中」 */
export const TRAIN_STOPPING = { label: '停止中', tag: 'info' };

/** 评估 run 状态（评估页与训练详情抽屉共用一套） */
export const EVAL_STATES = {
  running: { label: '评估中', tag: 'warning' },
  finished: { label: '已完成', tag: 'success' },
  finished_no_artifact: { label: '产物不全', tag: 'warning' },
  failed: { label: '失败', tag: 'danger' },
  stopped: { label: '已停止', tag: 'info' },
  unknown: { label: '未知', tag: 'info' },
};

/** 点了停止、容器还在收尾：状态列显示「停止中」 */
export const EVAL_STOPPING = { label: '停止中', tag: 'info' };

/** 评估报告已归档：产物/归档合列命中归档清单时的标记 */
export const EVAL_ARCHIVED = { label: '已归档', tag: 'success' };

/** 产物归档到 MinIO 的状态（训练任务页与训练详情抽屉共用一套） */
export const ARCHIVE_STATES = {
  pending: { label: '待归档', tag: 'info' },
  pushed: { label: '已归档', tag: 'success' },
  failed: { label: '归档失败', tag: 'danger' },
};

/** 推理实例状态（模型实例页与视频流页共用一套说法） */
export const INSTANCE_STATES = {
  stopped: { label: '已停止', tag: 'info' },
  loading: { label: '启动中', tag: 'warning' },
  ready: { label: '已启动', tag: 'success' },
  error: { label: '异常', tag: 'danger' },
};

/** 权重类型（模型实例页与模型详情抽屉共用一套） */
export const WEIGHT_TYPES = {
  base: { label: '基础权重', tag: 'success' },
  product: { label: '训练产物', tag: 'info' },
};

/**
 * 标注数据状态词表（两级）：一级用于「标注状态」列和筛选下拉，二级用于操作列 chip。
 * 后端仍下发 stage 九档；这里只做词面、筛选分组和二级默认值投影。
 */
export const PIPELINE_STATES = {
  none: { label: '生成数据', secondary: '待生成', tag: 'primary', filter: 'generating' },
  selecting: { label: '数据准备', secondary: '选图中', tag: 'primary', filter: 'preparing' },
  prepending: { label: '数据准备', secondary: '待预标注', tag: 'primary', filter: 'preparing' },
  unannotated: { label: '预标注', secondary: '排队中', tag: 'info', filter: 'preannotation' },
  preannotating: { label: '预标注', secondary: '预标注中', tag: 'primary', filter: 'preannotation' },
  prefailed: { label: '预标注', secondary: '漏产出结果', tag: 'warning', filter: 'preannotation' },
  awaiting: { label: '人工标注', secondary: '待人工标注', tag: 'primary', filter: 'human' },
  ready: { label: '已人工标注', secondary: '未验收', tag: 'success', filter: 'done', dest: '待发布' },
  in_set: { label: '已人工标注', secondary: '未验收', tag: 'success', filter: 'done', dest: '在数据集中' },
  removed: { label: '已人工标注', secondary: '未验收', tag: 'success', filter: 'done', dest: '已剔除' },
};

/** 筛选下拉项：一级状态去重；后端 dataset_state 接收 generating/preparing/preannotation/human/done 分组。 */
export function pipelineFilterOptions() {
  const opts = [];
  Object.keys(PIPELINE_STATES).forEach(stage => {
    const s = PIPELINE_STATES[stage];
    if (!opts.some(o => o.value === s.filter)) opts.push({ label: s.label, value: s.filter });
  });
  return opts;
}
